import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineImagesIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18 15V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3ZM4 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4.36l-1.08-1.09a2.56 2.56 0 0 0-1.81-.75 2.5799 2.5799 0 0 0-1.81.75l-.91.91-.81-.81a2.93 2.93 0 0 0-4.11 0L4 9.85V5Zm.12 10.45A.9401.9401 0 0 1 4 15v-2.33l2.88-2.88a.91.91 0 0 1 1.29 0l.83.81-4.88 4.85Zm8.6-5.76a.5196.5196 0 0 1 .39-.17.52.52 0 0 1 .39.17l2.5 2.49V15a1.0001 1.0001 0 0 1-1 1H6.4l6.32-6.31ZM21 6a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1.0002 1.0002 0 0 0-.7071 1.7071C6.4804 21.8946 6.7348 22 7 22h10a4.9997 4.9997 0 0 0 5-5V7a1.0002 1.0002 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineImagesIcon
